import { render, staticRenderFns } from "./quota.vue?vue&type=template&id=a92aeda2&scoped=true"
import script from "./quota.vue?vue&type=script&lang=js"
export * from "./quota.vue?vue&type=script&lang=js"
import style0 from "./quota.vue?vue&type=style&index=0&id=a92aeda2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92aeda2",
  null
  
)

export default component.exports